import React, { useState, useEffect } from "react";
import "./EntryLevelLearning.css";
import "../function-components/HomeContent.css";
import MenuNavbar from "../function-components/MenuNavbar";
import Floaticons from "../function-components/Floaticons";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SecurityInternship from "./SecurityInternship";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function EntryLevelLearning() {
  const [displaySkill, setDisplaySkill] = useState("tech-expressway");

  const [isFlipped, setIsFlipped] = useState(null);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [modalOpen, setModelOpen] = useState("");

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <>
      <div className="banner-container">
        <img src="images/Banner1.png" alt="banner" className="banner-img" />
        <MenuNavbar />
      </div>
      <Floaticons />

      {/* <div className="Network_tab_cont" id="EntryLearning">
        <a
          className={
            displaySkill === "tech-expressway"
              ? "Network_tab_tier-cap-active"
              : "Network_tab_tier-cap-inactive"
          }
          onClick={() => setDisplaySkill("tech-expressway")}
          href="#techexpressway"
        >
          Entry Level
        </a> */}
      {/* <a
          className={
            displaySkill === "campus-collaboration"
              ? "Network_tab_tier-mand-active"
              : "Network_tab_tier-mand-inactive"
          }
          onClick={() => {
            setDisplaySkill("campus-collaboration");
          }}
          href="#campuscollaboration"
        >
          Campus Collaboration
        </a> */}
      {/* <a
          className={
            displaySkill === "security-internship"
              ? "Network_tab_tier-cross-active"
              : "Network_tab_tier-cross-inactive"
          }
          onClick={() => {
            setDisplaySkill("security-internship");
          }}
          href="#securityinternship"
        >
          Security Internship
        </a>
      </div>

      <div className="Network_skill_tab_ELL">
        {displaySkill === "tech-expressway" ? (
          <div className="Network_skill_tile-container">
            <div className="techexpresscontent">
              <div className="techcontent">
                <p className="techpara">
                  Nurturing budding tech geeks in the security landscape is one
                  of our prime areas of focus. Tech Expressway is a 24 months
                  learning journey crafted for the Associate Software Engineers
                  (ASEs) as they embark on their corporate journey with
                  Accenture. Tech Expressway provides an all-inclusive learning
                  pathway focusing on technical and professional grooming of the
                  ASEs. The entire journey is divided two phases-Techgenics and
                  Techleap.
                </p>
                <a
                  href="https://atci.techexpressway.accenture.com/"
                  target="_blank"
                >
                  Click here for more details on Tech Expressway
                </a>
              </div>

              
              <div className="tech-container">
                <div className="tech-wrap">
                  <div className="tech-row">
                    <div className="tech-box">
                      <h2>Techgenics</h2>
                      <div className="flip-card">
                        <div class="flip-card-inner">
                          <div class="flip-card-front">
                            <img
                              src="images/EntryLevel/Techgenics.png"
                              alt="techgenic-img"
                              className="tech-img"
                            />
                          </div>
                          <div class="flip-card-back">
                            <p>
                              During the Shift-left Entry Level Program for Pre-Joiners, participants undergo learning interventions in a security skill aligned to specific offerings within the Security Capability. The learning journey spans 4–6 weeks and consists of full-time instructor-led sessions with  continuous assessments, including MCQs and hands-on assessment.
                            </p>

                            <p>
                              Successful completion of the Shift-left program is a mandatory prerequisite for onboarding into Accenture. Pre-Joiners are required to take the MyCompetency assessment for the respective skill in which they have completed the training and are expected to achieve a P2 proficiency level or above to be eligible for onboarding.
                            </p>

                            <p>
                              This entry-level training program provides fundamental and conceptual knowledge in the specific security domain that Pre-Joiners will work in, helping to bridge learning gaps and prepare them before they begin working in client environments.
                            </p> */}
      {/* <p>                  
                              During the Techgenics  phase of Tech Expressway,
                              ASEs undergo learning interventions in a security
                              skill aligned to  a specific practice and
                              sub-practice in Security Capability. The learning
                              journey spans over 4-6 weeks and is a blend of
                              Instructor led sessions, SME Connects, Self-paced
                              learning and continuous assessments.
                            </p>
                            <p>
                              Clearing Techgenics is linked to probation
                              clearance and is the basic threshold an ASE needs
                              to clear before getting aligned to a project
                              full-time. Techgenics provides fundamental and
                              conceptual knowledge on a particular domain the
                              ASE will be working into bridge gaps in learning
                              before they start working on client environments.
                            </p> */}
      {/* </div>
                        </div>
                      </div>
                      <h3
                        onClick={() => {
                          handleOpen();
                          setModelOpen("modal-one");
                        }}
                      >
                        ENTRY LEVEL STREAMS
                      </h3>
                    </div>
                    <div className="tech-vertical-line"></div>
                    <div className="tech-box">
                      <h2>Techleap</h2>
                      <div className="flip-card">
                        <div class="flip-card-inner">
                          <div class="flip-card-front">
                            <img
                              src="images/EntryLevel/TechLeap.png"
                              alt="techgenic-img"
                              className="tech-img"
                            />
                          </div>
                          <div class="flip-card-back">
                            <p>
                              TechLeap is the final stage of the Tech Expressway
                              Academy where ASEs get the unique opportunity to
                              deep dive into technologies most suited to the
                              business groups that they are part of. It is
                              proposed as an 18-month long journey with access
                              to schools across Security technology segments to
                              help you broaden and deepen your technical
                              expertise.
                            </p>
                            <p>
                              TechLeap is a learning journey available to all
                              ASEs after the successful completion of initial
                              Techgenics training. Completion of TechLeap
                              provides ASEs career growth opportunities subject
                              to other parameters, making it one of the most
                              sought-after learning programs.
                            </p>
                          </div>
                        </div>
                      </div>
                      <h3
                        onClick={() => {
                          handleOpen();
                          setModelOpen("modal-two");
                        }}
                      >
                        TECHLEAP SCHOOLS
                      </h3>
                    </div>
                  </div>

                  <Modal
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    {modalOpen == "modal-one" ? (
                      <Box className="techgenics-modal">
                        <img
                          src="images/EntryLevel/Close icon.png"
                          alt="close-icon"
                          onClick={handleClose}
                          className="close-icon1"
                        />
                        <img
                          src="images/EntryLevel/Techmap.png"
                          alt="techgenics-flowchart"
                          className="techgenics-infographic"
                        />
                      </Box>
                    ) : (
                      <Box className="techgenics-modal">
                        <h3>TECHLEAP SCHOOLS</h3>
                        <img
                          src="images/EntryLevel/Close icon.png"
                          alt="close-icon"
                          onClick={handleClose}
                          className="close-icon1"
                        />
                        <div className="techleap-modal-container">
                          <Box className="boxStyles">
                            <Box
                              sx={{ borderBottom: 0, borderColor: "divider" }}
                              className="tabMenuWrap"
                            > */}
      {/* <Tabs
                                value={value}
                                onChange={handleChange}
                                aria-label="basic tabs example"
                                centered
                              > */}
      {/* <Tab
                                  label="Cyber Strategy"
                                  {...a11yProps(0)}
                                  className="tabStyles"
                                />
                                <Tab
                                  label="Cyber Resilience"
                                  {...a11yProps(1)}
                                  className="tabStyles"
                                />
                                <Tab
                                  label="Cyber Protection"
                                  {...a11yProps(2)}
                                  className="tabStyles"
                                />
                              </Tabs> */}
      {/* </Box>
                            <TabPanel
                              className="tabPanelWrap"
                              value={value}
                              index={0}
                            >
                              <img
                                src="images/EntryLevel/Techleapmap.png"
                                alt=""
                                className="techleap-infographics info1"
                              />
                            </TabPanel>
                            <TabPanel
                              className="tabPanelWrap"
                              value={value}
                              index={1}
                            >
                              <img
                                src="images/Techleap2-Cyber-Resilience.png"
                                alt=""
                                className="techleap-infographics info2"
                              />
                            </TabPanel>
                            <TabPanel
                              className="tabPanelWrap"
                              value={value}
                              index={2}
                            >
                              <img
                                src="images/EntryLevel/CYBER-Protection.png"
                                alt=""
                                className="techleap-infographics info3"
                              />
                            </TabPanel>
                          </Box>
                        </div>
                      </Box>
                    )}
                  </Modal>
                </div>
              </div> */}

      {/* -------------OLD DESIGN-------------  */}

      {/* <div className="techgenicspara">
                            <div className="shell-container-ELL">
                                <div className="shell-wrap-ELL">
                                    <div className="shell-row-ELL row1">
                                        <div className="shell-box-ELL">
                                            <h2>Techgenics</h2>
                                            <p>
                                                During the Techgenics phase of Tech Expressway, ASEs undergo learning interventions in a security skill aligned to a specific practice and sub-practice in Security Capability.
                                                The learning journey spans over 4-6 weeks and is a blend of Instructor led sessions,
                                                SME Connects, Self-paced learning and continuous assessments.
                                            </p>
                                            <p>
                                                Clearing Techgenics is linked to probation clearance and is the basic threshold as ASE needs to clear before getting aligned to a project full-time.
                                                Techgenics provides fundamental and conceptual knowledge on a particular domain the ASE will be working into bridge gaps in learning before they start working on client environments.
                                            </p>
                                        </div>
                                    </div>
                                    <div className="shell-row-ELL row2">
                                        <div className="shell-box-ELL">
                                            <img src="images/Techgenics.png" alt="video" className='video-img-ELL' />
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div> */}

      {/* section 3 */}

      {/* <div className="FSE-container">
                            <Accordion className="accordion_container">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography className="accordianHead"> Techgenics Course Maps </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div className="coursemap">
                                            <img className="course" src="images/Techgenics-group.jpg" />
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>

                        <div className="techgenicspara">
                            <div className="shell-container-ELL">
                                <div className="shell-wrap-ELL2">
                                    <div className="shell-row-ELL row2">
                                        <div className="shell-box2-ELL">
                                            <img src="images/Techleap.png" alt="video" className='video-img-ELL' />
                                        </div>
                                    </div>
                                    <div className="shell-row-ELL row1">
                                        <div className="shell-box2-ELL">
                                            <h2>Techleap</h2>
                                            <p>
                                                TechLeap is the final stage of the Tech Expressway Academy where ASEs get the unique opportunity to deep dive into technologies most suited to the
                                                business groups that they are part of. It is proposed as an 18-month long
                                                journey with access to schools across Security technology segments to help
                                                you broaden and deepen your technical expertise.
                                            </p>
                                            <p>
                                                TechLeap is a learning journey available to all ASEs after the successful
                                                completion of initial Techgenics training. Completion of TechLeap provides
                                                ASEs career growth opportunities subject to other parameters, making it one of the most sought-after learning programs.
                                            </p>
                                        </div>
                                    </div>

                                </div>
                            </div>

                        </div>

                        <div className="FSE-container">
                            <Accordion className="accordion_container">
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2a-content"
                                    id="panel2a-header"
                                >
                                    <Typography className="accordianHead">Cyber Strategy</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div className="coursemap">
                                            <img className="course-cyberStrategy" src="images/Cyber-Strategy.jpg" />
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>

                        <div className="FSE-container">
                            <Accordion className="accordion_container" >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3a-content"
                                    id="panel3a-header"
                                >
                                    <Typography className="accordianHead">Cyber Resilience</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div className="coursemap">
                                            <img className="course" src="images/CyberResilience.jpg" />
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>

                        <div className="FSE-container">
                            <Accordion className="accordion_container" >
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel3a-content"
                                    id="panel3a-header"
                                >
                                    <Typography className="accordianHead">CYBER PROTECT</Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        <div className="coursemap">
                                            <img className="course" src="images/cyber-prot.jpg" />
                                        </div>
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div> */}
      {/* </div>
          </div>
        ) : (
          ""
        )} */}

      {/* {displaySkill === "campus-collaboration" ? (
          <div className="Network_skill_tile-container">
            <h1>Coming Soon!</h1>
          </div>
        ) : (
          ""
        )}

        {displaySkill === "security-internship" ? (
          <div className="Network_skill_tile-container">
            <SecurityInternship />
          </div>
        ) : (
          ""
        )}
      </div> */}
      <div className="professional-container">

        <p className="click-here-link">
          <a href="https://atci.entrylevellearning.accenture.com/" 
            target="_blank"
          >Click here</a> for more details on Entry Level Learning
        </p>
      </div>
    </>
  );
}

export default EntryLevelLearning;
